export const css = {
	root: '_2NqsF-te',
	card: 'AiS5X9Ey',
	title: '_3s3XXVGR',
	activity_intro: '_34PfLdda',
	teach_me: '_25oaF8Td',
	teach_me_tooltip: '_3km7j0MQ',
	quiz_me: '_2yzl6i7y',
	quiz_me_tooltip: '_18plWQpe',
	icon: '_35TjxIIK',
	close: '_3mX647EL',
	skel: 'qmiiCHuJ',
	skelWithTooltip: '_1qM1I2lC',
	enter: 'IW2tIHa4',
	'slide-in': '_1oUZRpVX',
	exit: '_2kxHKPMp',
	'slide-out': 'RrvBKp6_',
	expanded_content: '_2ca9MLyT',
	twoColumn: '_2k1jQbYn',
	shortDesc: 'ZtAcrV8l',
	topicgroups: '_3LLl3wUx',
	item: '_3gD6C9eN',
	topicquiz: '_2iKAM1Pc',
	' _key': 'certwise-theme/certwise/card/expanded'
};

export default css;
